import {DOCUMENT, inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {isPlatformBrowser} from '@angular/common';

@Injectable({providedIn: 'root'})
export class SeoService {

  private readonly title = inject(Title);
  private readonly meta = inject(Meta);
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);
  private readonly BASE_URL = 'https://landing.processway.com.pl/';

  public init(routeData: any): void {
    this.resetAll();

    if (!routeData) return;

    const meta = routeData['meta'];
    const title = routeData['title'];

    if (title) this.title.setTitle(title);

    if (meta?.description) {
      this.meta.updateTag({name: 'description', content: meta.description});
    }

    this.meta.updateTag({property: 'og:title', content: meta?.title || title || ''});
    this.meta.updateTag({property: 'og:description', content: meta?.description || ''});
    this.meta.updateTag({property: 'og:type', content: meta?.type || 'website'});
    this.meta.updateTag({property: 'og:image', content: meta?.image || ''});
    this.meta.updateTag({property: 'og:url', content: meta?.url || this.BASE_URL});

    this.meta.updateTag({name: 'twitter:card', content: 'summary_large_image'});
    this.meta.updateTag({name: 'twitter:title', content: meta?.title || title || ''});
    this.meta.updateTag({name: 'twitter:description', content: meta?.description || ''});
    this.meta.updateTag({name: 'twitter:image', content: meta?.image || ''});

    this.meta.updateTag({name: 'robots', content: meta?.robots || 'none'});
    this.meta.updateTag({name: 'googlebot', content: meta?.googlebot || 'none'});

    this.updateCanonical(meta?.url || this.BASE_URL);

    if (routeData['faviconUrl']) {
      this.updateFavicon(routeData['faviconUrl']);
    }
  }

  private resetAll() {
    if (!this.isBrowser) return;

    this.title.setTitle('');

    const tags = this.document.head.querySelectorAll(
      `meta[name], meta[property], link[rel='canonical'], link[rel~='icon']`
    );

    tags.forEach((tag: Element) => tag.remove());
  }

  private updateCanonical(url: string) {
    if (!this.isBrowser) return;

    let link = this.document.querySelector("link[rel='canonical']") as HTMLLinkElement | null;

    if (!link) {
      link = this.document.createElement('link') as HTMLLinkElement;
      link.rel = 'canonical';
      this.document.head.appendChild(link);
    }

    link.href = url;
  }

  private updateFavicon(url: string) {
    if (!this.isBrowser) return;

    let link = this.document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;

    if (!link) {
      link = this.document.createElement('link') as HTMLLinkElement;
      link.rel = 'icon';
      this.document.head.appendChild(link);
    }

    link.href = url;
  }
}
